import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

``

export class FlutterSensors extends BridgeMethod {
  /**
   *
   * @param callback {function({x,y,z,timestamp})}
   * @return {Promise<{cancel: Function}>}
   */
  onSensorsGyroscope(callback) {
    return on("onSensorsGyroscope", callback, {isSend: true});
  }

  offSensorsGyroscope(callback) {
    return cancel("onUsbDeviceStateChange", {event: callback, isSend: true});
  }

  /**
   *
   * @param callback {function({x,y,z,timestamp})}
   * @return {Promise<{cancel: Function}>}
   */
  onSensorsAccelerometer(callback) {
    return on("onSensorsAccelerometer", callback, {isSend: true});
  }

  offSensorsAccelerometer(callback) {
    return cancel("onSensorsAccelerometer", {event: callback, isSend: true});
  }
}

export const flutterSensors = new FlutterSensors();